<template>
<div class="chapter">
<div class="inner_page">
<div id="Prologue.html" xml:lang="en-US">
<div class="Basic-Text-Frame-29">
<p class="ch"><a id="Anchor-1">Prologue</a></p><a id="Anchor-1">
<p class="body-text-opening"><span class="caps-epub" xml:lang="en-US">HE SHOULD HAVE </span>killed the old man.</p>
<p class="body-text">The second he’d realized Harris had spotted him trespassing, he should’ve flanked the old man. Just crept around behind him and snapped his neck. Instead, he’d disappeared. Blended right into the woods and slipped away.</p>
<p class="body-text">And while he’d huddled in his car, cursing himself for getting distracted enough to let Harris spot him, the old man had kept looking. And the old man had found something.</p>
<p class="body-text">An angry tirade screamed in his mind as he watched another police car swing into Harris’s driveway, sirens blaring. All those months of scouting out the woods wasted. All that time finding the perfect place, making sure not even Harris would discover it, squandered. It’d been his secret hideaway, where he could display his trophies, revel in his triumphs.</p>
<p class="body-text">And Harris was ruining everything. Damn it! Why hadn’t he stopped the old man when he’d had the chance?</p>
<p class="body-text">By now, the cops were digging out his women, taking them away. By now, the cops were calling the FBI. Same way they had three years ago.</p>
<p class="body-text">Unease surfaced, mingling with the anger, blurring with guilt. Three years ago, he’d made one mistake. Made just one kill he regretted.</p>
<p class="body-text">But besides Diana, no one had ever suspected. And here in Virginia, no one knew him. The cops could call whoever they wanted; he’d taken precautions. They weren’t going to catch him.</p>
<p class="body-text">And he wasn’t finished yet.</p>
<p class="Basic-Paragraph-26">
</p></a></div><a id="Anchor-1">
</a></div><a id="Anchor-1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Prologue.vue?3072adbc